import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ccaa_actions } from "../../store/ccaa_slice";

import { Typography, Alert } from "antd";

import { Text } from "@chakra-ui/react";

const { Title } = Typography;

function Annual_reporting_summary() {
  //redux functions
  const dispatch = useDispatch();
  const annual_reporting_summary_values_store = useSelector(
    (state) => state.ccaa.annual_reporting_summary_store
  );
  const organization_name_store = useSelector(
    (state) => state.ccaa.organization_name_store
  );
  const annual_reporting_summary_default_values = {
    organization_name: organization_name_store,
    acres_enrolled: "",
    acres_target: "",
    acres_contributed: "",
    additional_explanation: ""
  };
  const [annual_reporting_summary_values, setAnnualReportingSummaryValues] =
    React.useState(annual_reporting_summary_default_values);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ccaa_actions.set_annual_reporting_summary(annual_reporting_summary_values)
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAnnualReportingSummaryValues({
      ...annual_reporting_summary_values,
      [name]: value
    });
    //dispatch to store
    dispatch(
      ccaa_actions.set_annual_reporting_summary(annual_reporting_summary_values)
    );
  };

  const handleTotalAcresEnrolled = (e) => {
    const { value } = e.target;
    if (sessionStorage.getItem("total_enrolled_lands")) {
      if (sessionStorage.getItem("total_enrolled_lands") !== value) {
        var invalid_feedback = document.getElementsByClassName("invalid-total");
        invalid_feedback[0].style.display = "block";
      } else if (sessionStorage.getItem("total_enrolled_lands") === value) {
        var invalid_feedback = document.getElementsByClassName("invalid-total");
        invalid_feedback[0].style.display = "none";
      }
    } else {
      var invalid_feedback = document.getElementsByClassName("invalid-total");
      invalid_feedback[0].innerHTML =
        "No Matching Records are found for the provided Inclusion Number.";
      invalid_feedback[0].style.display = "block";
    }
  };

  const handleAdoptedAcres = (e) => {
    const { value } = e.target;
    if (sessionStorage.getItem("adopted_acres")) {
      if (sessionStorage.getItem("adopted_acres") !== value) {
        var invalid_feedback =
          document.getElementsByClassName("invalid-adopted");
        invalid_feedback[0].style.display = "block";
      } else if (sessionStorage.getItem("adopted_acres") === value) {
        var invalid_feedback =
          document.getElementsByClassName("invalid-adopted");
        invalid_feedback[0].style.display = "none";
      }
    } else {
      var invalid_feedback = document.getElementsByClassName("invalid-adopted");
      //set html to invalid adoption number
      invalid_feedback[0].innerHTML =
        "No Matching Records are found for the provided Inclusion Number.";
      invalid_feedback[0].style.display = "block";
    }
  };

  const text_input_width = window.innerWidth * 0.5;
  const text_input_height = window.innerHeight * 0.05;
  const text_area_width = window.innerWidth * 0.5;
  const text_area_height = window.innerHeight * 2;

  useEffect(() => {
    dispatch(
      ccaa_actions.set_annual_reporting_summary(annual_reporting_summary_values)
    );
  }, [annual_reporting_summary_values]);

  useEffect(() => {
    //set organization name
    setAnnualReportingSummaryValues({
      ...annual_reporting_summary_values,
      organization_name: organization_name_store
    });
    setAnnualReportingSummaryValues(annual_reporting_summary_values_store);
    //hide the all div with class 'invalid-feedback' from the DOM
    var invalid_feedback = document.getElementsByClassName("invalid-total");
    invalid_feedback[0].style.display = "none";
    var invalid_adopted = document.getElementsByClassName("invalid-adopted");
    invalid_adopted[0].style.display = "none";
  }, []);


  return (
    <>
      <div className="container">
        <>
          <Title level={3}>Annual Reporting Summary</Title>
          <div className="mt-2 mb-2">
            <label type="text">
              Enter enrolled and adopted acres totals for this past year.
            </label>
          </div>
        </>
        <div className="mt-2 mb-2">
          <Alert
            message="Please note your responses are saved automatically"
            type="info"
            showIcon
          />
        </div>

        <form onSubmit={handleFormSubmit}>
          <div className="p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>Acres Enrolled in 2024</Title>
                <div id="total_acres_enrolled">
                  <Text>
                    Enter the total acres enrolled according to your Certificate
                    of Inclusion. Round to the nearest acre.
                  </Text>
                </div>
                <div>
                  <input
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="acres_enrolled"
                    placeholder="Acres Enrolled"
                    name="acres_enrolled"
                    defaultValue={
                      annual_reporting_summary_values_store &&
                      annual_reporting_summary_values_store.acres_enrolled
                      ? parseInt(annual_reporting_summary_values_store.acres_enrolled).toLocaleString("en-US"): ""
                    }
                    onBlur={(e) => {
                      handleInputChange(e);
                      handleTotalAcresEnrolled(e);
                    }}
                  />
                </div>
                <div className="invalid-total inv">
                  Our records indicate the enrolled acres target on your
                  Certificate of Inclusion as{" "}
                  {sessionStorage.getItem("total_enrolled_lands")}. Please
                  provide additional details below on the reason for this
                  discrepancy.
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>Adopted Acres Target for 2024</Title>
                <div>
                  <Text>
                    Enter the adopted acres target specified in your Certificate
                    of Inclusion or the interim adopted acres target specified
                    in your application as part of an implementation schedule.
                    Round to the nearest acre.
                  </Text>
                </div>
                <div>
                  <input
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="acres_target"
                    placeholder="Acres Target"
                    name="acres_target"
                    defaultValue={
                      annual_reporting_summary_values_store.acres_target
                        ? parseInt(annual_reporting_summary_values_store.acres_target).toLocaleString("en-US")
                        : ""
                    }
                    onBlur={(e) => {
                      handleInputChange(e);
                      handleAdoptedAcres(e);
                    }}
                  />
                </div>
                <div className="invalid-adopted inv">
                  Our records indicate the adopted acres target on your
                  Certificate of Inclusion as{" "}
                  {sessionStorage.getItem("adopted_acres")}. Please provide
                  additional details below on the reason for this discrepancy.
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>Adopted Acres Contributed in 2024</Title>
                <div>
                  <Text>
                    Enter the actual adopted acres where conservation measures
                    were implemented. This amount should be equal to, or greater
                    than, the adopted acres target specified in your Certificate
                    of Inclusion. Round to the nearest acre.
                  </Text>
                </div>
                <div>
                  <input
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="acres_contributed"
                    placeholder="Acres Contributed"
                    name="acres_contributed"
                    defaultValue={
                      annual_reporting_summary_values_store.acres_contributed
                        ? parseInt(annual_reporting_summary_values_store.acres_contributed).toLocaleString("en-US")
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <div>
                  <Text>
                    If necessary, provide additional explanation or comments
                    related to the enrolled acres and adopted acres values given
                    above.
                  </Text>
                </div>
                <div>
                  <textarea
                    rows={10}
                    width={text_area_width}
                    height={text_area_height}
                    type="text"
                    className="form-control"
                    id="additional_explanation"
                    name="additional_explanation"
                    defaultValue={
                      annual_reporting_summary_values_store.additional_explanation
                        ? annual_reporting_summary_values_store.additional_explanation
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="form-group mt-4">
                <ReactStrapButton color="primary" type="submit">Save</ReactStrapButton>
                {isLoading && requestPosted ? (<div className='mt-2 row'>
                    <div className='col-md-6'>
                      <Text fontSize={'md'} color={'gray.600'}>Posting to ROWHWG Database</Text>
                    </div>
                    <div className='col-md-6'>
                      <Spinner />
                    </div>
                  </div>): null}
            </div> */}
        </form>
      </div>
    </>
  );
}

export default Annual_reporting_summary;
